import { render, staticRenderFns } from "./serve.vue?vue&type=template&id=694e7b3c&scoped=true"
import script from "./serve.vue?vue&type=script&lang=js"
export * from "./serve.vue?vue&type=script&lang=js"
import style0 from "./serve.vue?vue&type=style&index=0&id=694e7b3c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694e7b3c",
  null
  
)

export default component.exports